import React from 'react'
import { IQueryBuilderComponent } from '../IQueryBuilderComponent'
import { createParameter } from '../../lib/api'

interface IState {
  value?: string
}

class FilterByEmailCriteria extends IQueryBuilderComponent<{}, IState> {
  state: IState = {}

  handleChange = (value?: string) => {
    this.setState({ value })
  }

  getParameters() {
    return [createParameter('email', this.state.value || '')]
  }

  getType() {
    return 'email'
  }

  render() {
    return (
      <>
        <div className="four wide column">
          <h4>Email address</h4>
        </div>
        <div className="eight wide column">
          <div className="ui form">
            <div className="field">
              <input
                name="email"
                value={this.state.value}
                onChange={e => this.handleChange(e.target.value)}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default FilterByEmailCriteria
